import React from 'react';
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

// The dialog every edit uses: a title, the fields, the problem (if any) and Save / Cancel. `problem` is what is wrong
// with what was typed (shown, and Save is off); `error` is what the API said.
export function EditDialog({ open, title, onClose, onSave, saving, problem, error, children, saveLabel = 'Save' }) {
  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="md" aria-label={title}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {children}
          {problem && <Typography variant="body2" color="warning.main">{problem}</Typography>}
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button variant="contained" onClick={onSave} disabled={saving || Boolean(problem)} startIcon={saving ? <CircularProgress size={16} /> : null}>
          {saveLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// "Delete this?" with what will happen. The deletion is recorded in the history, which cannot be deleted.
export function ConfirmDialog({ open, title, text, onCancel, onConfirm, busy, error }) {
  return (
    <Dialog open={open} onClose={busy ? undefined : onCancel} aria-label={title}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2">{text}</Typography>
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>Cancel</Button>
        <Button color="error" variant="contained" onClick={onConfirm} disabled={busy}>Delete</Button>
      </DialogActions>
    </Dialog>
  );
}
